import { Get, PostForm } from "@/request/http";

// 获取产品列表
export const getProducts = (data) => Get("/workai/index/products", data);
// 获取 360 联运配置（app_id / qid，用于 SDK360.init）
export const get360Config = () => Get("/workai/pay360/config");
// 创建 360 联运订单
export const create360Order = (data) => PostForm("/workai/pay360/order", data);
// 历史订单查询
export const getHistoryList = (data) => Get("/v2/workai/order/list", data);
